import { companiesSelector, CompanySelectorProps, useGetAllCompaniesQuery } from "@ots-frontend/ots-data";
import { useMemo } from "react";
import { BaseCompanySelect, BaseCompanySelectProps } from "./BaseCompanySelect";

export type CompanySelectProps = Omit<BaseCompanySelectProps, "entities" | "loading"> & {
  selector?: CompanySelectorProps
}

export const CompanySelect = (props: CompanySelectProps) => {
  const { selector, ...rest } = props;

  const selectCompanies = useMemo(() => {
    return companiesSelector();
  }, []);

  const { companies, isLoading } = useGetAllCompaniesQuery(selector?.regionId, {
    selectFromResult: (result) => ({
      companies: selectCompanies(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BaseCompanySelect entities={companies} loading={isLoading} {...rest} />;
};
